import axios from "axios";

const BASE_PATH = "/SalaryStr";

const GetSalaryStructures = async () => {
  return axios.get(`${BASE_PATH}/GetSalaryStructures`);
};

const AddSalaryStructure = async (payload) => {
  return axios.post(
    `${BASE_PATH}/AddSalaryStructure`,
    {
      p_structureCode: payload.structureCode,
      p_catCode: payload.categoryCode,
      p_structureName: payload.structureName,
      p_effectiveDate: payload.effectiveDate,
      p_structureIsActive: payload.isActive ?? true,
      p_structureRemarks: payload.remarks ?? "",
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const UpdateSalaryStructure = async (payload) => {
  return axios.post(
    `${BASE_PATH}/UpdateSalaryStructure`,
    {
      p_structureId: payload.structureId,
      ...(payload.categoryCode !== undefined && { p_catCode: payload.categoryCode }),
      ...(payload.structureName !== undefined && { p_structureName: payload.structureName }),
      ...(payload.effectiveDate !== undefined && { p_effectiveDate: payload.effectiveDate }),
      ...(payload.isActive !== undefined && { p_structureIsActive: payload.isActive }),
      ...(payload.remarks !== undefined && { p_structureRemarks: payload.remarks }),
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const DeleteSalaryStructure = async (structureId) => {
  return axios.post(
    `${BASE_PATH}/DeleteSalaryStructure`,
    {
      p_structureId: structureId,
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const GetAllStructureComponents = async () => {
  return axios.get(`${BASE_PATH}/GetAllStructureComponents`);
};

const GetStructureComponents = async (structureId) => {
  return axios.get(`${BASE_PATH}/GetStructureComponents`, {
    params: {
      p_structureId: structureId,
    },
  });
};

const AddStructureComponent = async (payload) => {
  return axios.post(
    `${BASE_PATH}/AddStructureComponent`,
    {
      p_structureId: payload.structureId,
      p_componentId: payload.componentId,
      p_defaultAmount: payload.defaultAmount ?? null,
      p_defaultPercentage: payload.defaultPercentage ?? null,
      p_sortOrder: payload.sortOrder ?? 1,
      p_isRequired: payload.isRequired ?? true,
      p_detailIsActive: payload.isActive ?? true,
      p_detailRemarks: payload.remarks ?? "",
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const UpdateStructureComponent = async (payload) => {
  return axios.post(
    `${BASE_PATH}/UpdateStructureComponent`,
    {
      p_structureDetailId: payload.structureDetailId,
      ...(payload.defaultAmount !== undefined && { p_defaultAmount: payload.defaultAmount }),
      ...(payload.defaultPercentage !== undefined && { p_defaultPercentage: payload.defaultPercentage }),
      ...(payload.sortOrder !== undefined && { p_sortOrder: payload.sortOrder }),
      ...(payload.isRequired !== undefined && { p_isRequired: payload.isRequired }),
      ...(payload.isActive !== undefined && { p_detailIsActive: payload.isActive }),
      ...(payload.remarks !== undefined && { p_detailRemarks: payload.remarks }),
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const DeleteStructureComponent = async (structureDetailId) => {
  return axios.post(
    `${BASE_PATH}/DeleteStructureComponent`,
    {
      p_structureDetailId: structureDetailId,
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const salaryStructureService = {
  GetSalaryStructures,
  AddSalaryStructure,
  UpdateSalaryStructure,
  DeleteSalaryStructure,
  GetAllStructureComponents,
  GetStructureComponents,
  AddStructureComponent,
  UpdateStructureComponent,
  DeleteStructureComponent,
};

export default salaryStructureService;